
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/post-topic/[topic]",
      function () {
        return require("private-next-pages/p/post-topic/[topic].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/post-topic/[topic]"])
      });
    }
  